<template lang="pug">
  #app
    keep-alive(:include="keepAlive")
      router-view
</template>

<script>
export default {
  name: 'App',
  computed: {
    keepAlive() {
      return this.$store.getters.keepAlive;
    },
  },
};
</script>

<style lang="less">
  @import './styles/index.less';
</style>
